import { useEffect } from 'react';
import { useAppSelector } from '@/app/hooks';
import { analytics } from '@/services/analytics';

export const useAnalytics = () => {
  const userId = useAppSelector(state => state.auth.user?.id ?? null);
  const anonymousId = useAppSelector(state => state.auth.temporaryUserId ?? null);

  useEffect(() => {
    analytics.setIdentity({ userId, anonymousId });
  }, [userId, anonymousId]);

  return analytics;
};
